import Vue from 'vue';

import { apiPath } from '../constants';

const AdInsight = Vue.resource(
  `${apiPath}/adbazaar/email-management/settings{/emailId}/`,
  {},
  {},
);

export default AdInsight;
